<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 lg6 offset-lg3>
        <v-alert
          v-model="isError"
          dismissible
          type="error"
          transition="fade-transition"
        >
          {{ errMessage }}
        </v-alert>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 lg6 offset-lg3>
        <h1>Reset Password</h1>
        <p>Please check your email for a token value and paste it here</p>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4>
        <v-form @submit.prevent="submit">
          <v-layout column>
            <v-flex>
              <v-text-field
                v-model="token"
                :disabled="tokenDisabled"
                label="Reset Token"
                required
                :error-messages="errors.token"
                id="token"
                @focus="inputFocus"
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="email"
                label="Email Address"
                required
                :error-messages="errors.email"
                id="email"
                @focus="inputFocus"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="password"
                label="New Password"
                type='password'
                required
                :error-messages="errors.password"
                id="password"
                @focus="inputFocus"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="confirm"
                label="Confirm Password"
                type='password'
                required
                :error-messages="errors.confirm"
                id="confirm"
                @focus="inputFocus"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-btn
                block
                type="submit"
                id="submit"
                :loading="isLoading"
                :disabled="isLoading"
              >
                Set New Password
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    token: '',
    tokenDisabled: false,
    email: '',
    password: '',
    confirm: '',
    isLoading: false,

    isError: false,
    errMessage: null,
    errors: {
      token: null,
      email: null,
      password: null,
      confirm: null
    }
  }),
  methods: {
    submit () {
      // Try to reset our password
      this.isLoading = true
      this.axios.post('/auth/passwordreset/confirmation', {
        token: this.token,
        email: this.email,
        password: this.password,
        confirm: this.confirm
      })
        .then(() => {
          // If we had success, redirect the user to the login page
          this.$router.push('/login')
        })
        .catch(this.$root.apiErrorHandler((msg, errors) => {
          this.isLoading = false
          this.errMessage = msg
          this.errors = errors
          this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  },
  mounted: function () {
    // If we have a token in the URL, pre-populate it
    if (this.$route.params.token) {
      this.token = this.$route.params.token
      this.tokenDisabled = true
    }
  }
}
</script>
